export const participantsList = {
    GET_LIST_PARTICIPANTS: "GET_LIST_PARTICIPANTS",
    GET_LIST_PARTICIPANTS_SUCCESS : "GET_LIST_PARTICIPANTS_SUCCESS",
    GET_LIST_PARTICIPANTS_NULL : "GET_LIST_PARTICIPANTS_NULL",
    GET_LIST_PARTICIPANTS_ERROR : "GET_LIST_PARTICIPANTS_ERROR",
    GET_NEW_ITEMS_ON_SCROLL : "GET_NEW_ITEMS_ON_SCROLL",
    CLEAR_FILTERS: "CLEAR_FILTERS",
    CLEAR_PARTICIPANTS_LIST: "CLEAR_PARTICIPANTS_LIST"
}